import {ManagedStream} from '@quobis/sippojs';
import React, {ReactElement} from 'react';

interface IProps {
	managedStream: ManagedStream;
}

export default function AudioComponent(props: IProps): JSX.Element {

	const getAudio = (): ReactElement | null => {
		if (props.managedStream) {
			return <audio autoPlay
				ref={
					(element) => {
						if (element && props.managedStream.mediaStream) {
							element.srcObject = props.managedStream.mediaStream;
						}
					}
				}
			/>;
		}
		return null;
	};

	return (
		<div >
			{ getAudio() }
		</div>
	);
}
